import { dataLoaderVariant } from '@gef-ui/material-theme-utils/FormControl';
export default function FormControl() {
    return {
        MuiFormControl: {
            styleOverrides: {
                root: {
                    variants: [
                        dataLoaderVariant
                    ]
                }
            }
        }
    };
}
